import { QUERY_PARAM_SORT, QUERY_PARAM_PAGE } from './filter-keys';

const QUERYSTRING_WHITELIST: string[] = [QUERY_PARAM_SORT, QUERY_PARAM_PAGE];

export default QUERYSTRING_WHITELIST;
